<template>
    <div>
        <Header />
        <PageTitle />
        <ProductDetailsContent />
        <Footer />
    </div>
</template>

<script>
import Header from '../Layout/Header'
import PageTitle from '../ProductDetails/PageTitle'
import ProductDetailsContent from '../ProductDetails/ProductDetailsContent'
import Footer from '../Layout/Footer'

export default {
    name: 'ProductDetailsPage',
    components: {
        Header,
        PageTitle,
        ProductDetailsContent,
        Footer,
    }
}
</script>